var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", [
        _c("h3", { staticClass: "mb-5" }, [
          _vm._v("¿Qué cuenta como una transacción?")
        ]),
        _c("p", {}, [
          _c("b", [
            _vm._v(
              "Es una transacción cualquier acción que se realice sobre un archivo (principal o adjunto), tales como carga, descarga, visualización, actualización y eliminación. Así como también el envío de un archivo a un flujo de revisión/aprobación o firma y cada evento de aprobación y firma que se realice sobre ese archivo. Por último, cada notificación por correo que se efectúe sobre los archivos o documentos."
            )
          ])
        ]),
        _c("br"),
        _c("h3", { staticClass: "mb-5" }, [
          _vm._v("¿Qué no es una transacción?")
        ]),
        _c("p", [
          _c("b", [
            _vm._v(
              "No es una transacción los cambios de atributos de los archivos sobre los campos editables que tienen las pestañas Información, Comentarios, Permisos y Suscripciones."
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }